import {combineReducers} from 'redux';
import articles, {Articles} from './articles';
import article, {Article} from './article';
import search from './search';
import experiments, {Experiments} from './experiments';
import subscriptions, {Subscriptions} from './subscriptions';

import user from './user';

export interface State {
  articles: Articles;
  article: Article;
  search: any;
  experiments: Experiments;
  user: any;
  subscriptions: Subscriptions;
}

export default combineReducers<State>({
  articles,
  article,
  search,
  experiments,
  user,
  subscriptions,
});
